import { Expose } from 'class-transformer';

export class MatchResponseEntity {
  @Expose()
  match: boolean;
}
